<planone-swiper
  [enableZoom]="false"
  [showSlideCount]="false"
  [showSlideNav]="false"
  [forceAspectRatio]="false"
  [swiperOptions]="{
    slidesPerView: brands?.length ?? 0 > 1 ? 1.2 : 1,
    spaceBetween: 3
  }"
  [moveToBack]="!!imageZoomed"
  desktopVariant="list"
  mobileVariant="cards"
  class="brands">
  @for (brand of brands; track identifyBrand($index, brand)) {
  <ng-template #slide>
    <bau365-brand-card [brand]="brand"></bau365-brand-card>
  </ng-template>
  }
</planone-swiper>
